import { AppConfigs } from './AppConfigs/AppConfigs';

export const services = {};

export const staticWebStaticAdminBotPaths = [];

export const appWebStaticAdminConfig = new AppConfigs<typeof services>({
	servicesHosts: {},
	appHostName: 'webStaticAdmin',
});
export type AppWebStaticAdminConfig = AppConfigs<typeof services>;
